import { useState } from 'react';
import './LandingPageExt.scss';
import useDevicePermissions from '../hooks/useDevicePermissions';
import LandingCarousel from './LandingCarousel';
import LandingCameraPermissionDenied from './LandingCameraPermissionDenied';

export default function LandingPageExt({ onEnterExperience, shouldFadeIn = false }) {
  const [isFadingOut, setIsFadingOut] = useState(false);
  const [showPermissionDenied, setShowPermissionDenied] = useState(false);
  const { error, requestPermissions } = useDevicePermissions();

  const handleEnterExperience = async () => {
    const granted = await requestPermissions();
    
    if (!granted) {
      setShowPermissionDenied(true);
      return;
    }

    setIsFadingOut(true);
    if (onEnterExperience) {
      onEnterExperience();
    }
  };

  const handleContinueWithoutPermission = () => {
    setShowPermissionDenied(false);
    setIsFadingOut(true);
    if (onEnterExperience) {
      onEnterExperience();
    }
  };

  const handleRetryPermissions = async () => {
    const granted = await requestPermissions();
    if (granted) {
      setShowPermissionDenied(false);
      setIsFadingOut(true);
      if (onEnterExperience) {
        onEnterExperience();
      }
    }
  };

  if (showPermissionDenied) {
    return (
      <LandingCameraPermissionDenied 
        onContinue={handleContinueWithoutPermission}
        onRetry={handleRetryPermissions}
      />
    );
  }

  return (
    <div className={`landing-page-ext ${isFadingOut ? 'landing-page-ext--fade-out' : ''} ${shouldFadeIn ? 'landing-page-ext--fade-in' : ''}`}>
      <div className="landing-page-ext__logo">
        <img src="/images/logo.svg" alt="Joby Logo" />
      </div>

      <h1 className="landing-page-ext__headline">
        Skip traffic.
        <br />
        Time to fly.
      </h1>

      <div className="landing-page-ext__description">
        <p>Enable camera access to see <br/>
        what the future looks like.</p>
      </div>

      <div className="landing-page-ext__cta-container">
        <button
          className="landing-page-ext__cta"
          onClick={handleEnterExperience}
        >
          See your ride
        </button>
        <div className="landing-page-ext__disclaimer">
            <p>Not currently available. Coming soon to select city skies.</p>
        </div>
      </div>
    </div>
  );
}

